import React from 'react';
import { Link } from 'react-router-dom';
import { Layers, Globe, Award, Sparkles } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const iconMap = { Layers, Globe, Award, Sparkles };

export default function WhyUs() {
  return (
    <section className="relative py-20 sm:py-24 lg:py-28 bg-[#0a1b35] overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-25" />

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-14">
        <div className="lg:col-span-5 lg:sticky lg:top-32 lg:self-start">
          <p className="text-[#e8b863] tracking-[0.28em] text-[11px] font-semibold uppercase mb-5">
            Why Salihi Consulting
          </p>
          <h2 className="font-serif text-white font-medium text-[32px] sm:text-[40px] lg:text-[50px] leading-[1.08] tracking-tight">
            The advantage of working with{' '}
            <span className="italic gold-gradient">a firm that does it all — well.</span>
          </h2>
          <p className="mt-6 sm:mt-7 text-white/72 text-[15.5px] lg:text-[16.5px] leading-relaxed">
            Most consulting engagements fail at the seams between disciplines.
            Our integrated team eliminates those seams so your strategy, finance, technology and people
            move in lock-step.
          </p>
          <Link
            to="/contact"
            className="mt-8 inline-flex items-center gap-3 px-7 py-4 rounded-full bg-gradient-to-r from-[#d49d3f] to-[#b8842a] hover:from-[#e8b863] hover:to-[#d49d3f] text-[#0a1b35] font-semibold text-[14px] tracking-wide transition-all duration-300 shadow-xl shadow-[#d49d3f]/25 hover:-translate-y-0.5"
          >
            Start a Conversation
          </Link>
        </div>

        <div className="lg:col-span-7 space-y-5">
          {whyChooseUs.map((item, idx) => {
            const Icon = iconMap[item.icon] || Layers;
            return (
              <div
                key={item.title}
                className="group relative bg-gradient-to-br from-white/[0.06] to-white/[0.02] border border-white/10 rounded-2xl p-6 sm:p-8 lg:p-9 hover:border-[#e8b863]/45 transition-all duration-500 overflow-hidden"
              >
                <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: 'radial-gradient(circle, rgba(232,184,99,0.18) 0%, transparent 70%)' }} />
                <div className="relative flex items-start gap-5">
                  <div className="flex-shrink-0">
                    <span className="font-serif text-[#e8b863]/35 text-[36px] sm:text-[40px] leading-none">
                      0{idx + 1}
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-lg bg-[#e8b863]/12 border border-[#e8b863]/30 flex items-center justify-center group-hover:bg-[#e8b863] transition-colors duration-300">
                        <Icon className="w-4 h-4 text-[#e8b863] group-hover:text-[#0a1b35] transition-colors" strokeWidth={1.5} />
                      </div>
                      <h3 className="text-white font-semibold text-[17px] sm:text-[19px]">
                        {item.title}
                      </h3>
                    </div>
                    <p className="text-white/72 text-[14px] sm:text-[15px] leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
